import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gCopyCss = ".g__copy{display:block;margin-bottom:2rem;}.g__copy>div{display:inherit}.g__copy a:link,.g__copy a:visited,.g__copy a:active{color:#000}.g__copy a:hover{color:#000}.g__copy--light,.g__copy--gray{color:#000;background:transparent}.g__copy--dark{color:#fff;background:#000}.g__copy--dark a:link,.g__copy--dark a:visited,.g__copy--dark a:hover,.g__copy--dark a:focus,.g__copy--dark a:active{color:#fff}.g__copy--blue a:link,.g__copy--blue a:visited,.g__copy--blue a:active{color:#106fad}.g__copy--blue a:hover{color:#106fad}.g__copy--left,.g__copy--left th{text-align:left}.g__copy--justify,.g__copy--justify th{text-align:justify}.g__copy--center,.g__copy--center th{text-align:center}.g__copy--right,.g__copy--right th{text-align:right}.g__copy--footnote,.g__copy--footnote table{font-size:0.6875rem}.g__copy--small,.g__copy--small table,.g__copy--detail,.g__copy--detail table{font-size:0.875rem}.g__copy--primary,.g__copy--primary table{font-size:16px}.g__copy--large,.g__copy--large table,.g__copy--intro,.g__copy--intro table{font-size:1.125rem}.g__copy ul li,.g__copy ol li{text-align:left}.g__copy img{max-width:100%}";
const GCopyStyle0 = gCopyCss;

const GCopy = /*@__PURE__*/ proxyCustomElement(class GCopy extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.textAlign = 'left';
        this.type = 'primary';
        this.theme = 'light';
        this.linkColor = undefined;
        this.styleObject = undefined;
        this.dataTestId = undefined;
    }
    render() {
        var _a;
        const baseClass = 'g__copy';
        const hasLinkColor = () => {
            const isLightTheme = this.theme.toLowerCase() !== 'dark';
            const isLinkBlue = this.linkColor === 'blue';
            if (isLinkBlue && isLightTheme) {
                return this.linkColor;
            }
        };
        const componentClasses = {
            [baseClass]: true,
            [`${baseClass}--${this.textAlign}`]: Boolean(this.textAlign),
            [`${baseClass}--${this.theme}`]: Boolean(this.theme),
            [`${baseClass}--${this.type}`]: Boolean(this.type),
            [`${baseClass}--${hasLinkColor()}`]: Boolean(hasLinkColor()),
        };
        return (h(Host, { class: componentClasses, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass, style: this.styleObject || null }, h("slot", null)));
    }
    static get style() { return GCopyStyle0; }
}, [4, "g-copy", {
        "textAlign": [513, "text-align"],
        "type": [513],
        "theme": [513],
        "linkColor": [513, "link-color"],
        "styleObject": [8, "style-object"],
        "dataTestId": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-copy"];
    components.forEach(tagName => { switch (tagName) {
        case "g-copy":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GCopy);
            }
            break;
    } });
}

export { GCopy as G, defineCustomElement as d };

//# sourceMappingURL=g-copy2.js.map